// extracted by mini-css-extract-plugin
module.exports =  {"modal-support-form":"SupportMessage-NjV2__modal-support-form","note":"SupportMessage-m_lL__note"};